/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ResetPwAliases {
  BUTTON_CONFIRM = 'button-confirm',
  BUTTON_OK = 'button-ok',
  FETCH_RECAPTCHA = 'fetch-recaptcha',
  FIELD_RECAPTCHA = 'field-recaptcha',
  FIELD_USER = 'field-user',
  FORM_RESET_PW = 'form-reset-pw',
  IMAGE_0 = 'image-0',
  INPUT_0 = 'input-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LOADER_0 = 'loader-0',
  MODAL_RESET_PW = 'modal-reset-pw',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_LOADER = 'panel-loader',
  PANEL_SCREEN = 'panel-screen',
  PANEL_SUCCESS = 'panel-success',
  PANEL_TITLE = 'panel-title',
  PANEL_TOAST = 'panel-toast',
  RECAPTCHA = 'recaptcha',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_TEXT = 'text-text',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ResetPwAliases };
